import { useEffect } from 'react';
import ReactGA from 'react-ga4';

import { GOOGLE_ANALYTICS_ID } from '../../../platforms/web/src/config/clientEnvConfig';
import { useConfigStore } from '@jwp/ott-common/src/stores/ConfigStore';

const analyticsInitialized = {
  GA4: false,
  GTM: false,
};

export const useAnalytics = () => {
  const { analyticsConfig } = useConfigStore.getState();

  const { analytics } = analyticsConfig;

  useEffect(() => {
    if (!analytics?.enabled) { return; }

    // Initialize GTM
    if (analytics.providers?.includes('GTM') && !analyticsInitialized.GTM) {
      window.dataLayer = window.dataLayer || [];
      analyticsInitialized.GTM = true;
    }

    // Initialize GA4
    if (analytics.providers?.includes('GA4') && !analyticsInitialized.GA4 && GOOGLE_ANALYTICS_ID) {
      ReactGA.initialize(GOOGLE_ANALYTICS_ID);
      analyticsInitialized.GA4 = true;
    }
  }, [analytics]);
};

/**
 * Send analytics event based on local analytics config (formerly Firebase Remote Config).
 * @param action - event name
 * @param params - raw payload from caller
 */
export const sendGAEvent = (action: string, params: Record<string, any> = {}) => {
  const config = window.analyticsConfig?.analytics?.events?.[action];

  if (!window.analyticsConfig?.analytics?.enabled || !config?.enabled) { return; }

  let finalParams = params;
  if (config.parameters && Array.isArray(config.parameters)) {
    finalParams = Object.fromEntries(Object.entries(params).filter(([key]) => config?.parameters?.includes(key)));
  }

  // ---- Send to GA4 ----
  if (window.analyticsConfig.analytics.providers.includes('GA4')) {
    ReactGA.event(action, {
      ...finalParams,
      platform: 'Web',
    });
  }

  // ---- Send to GTM ----
  if (window.analyticsConfig.analytics.providers.includes('GTM')) {
    window.dataLayer?.push({
      event: action,
      ...finalParams,
      platform: 'Web',
    });
  }
};

export default useAnalytics;
